(function( $ ){
    $( document ).ready( function(){
        hbspt.forms.create({ 
            css: '',
            cssClass: 'grcc-newsletter-form',
            portalId: '1843383',
            formId: '7316cede-3b35-4b2d-8632-f33bf934a724',
            target: '#grc-form-blog',
            submitButtonClass: 'btn btn-secondary'
        });
    });
})(jQuery);

import './infinite';